export default "__VITE_PUBLIC_ASSET__8f551e53__"